export enum ReportChartFeedbackBaseType {
  FEEDBACK_BASED = 'feedback_based',
  QUESTION_BASED = 'question_based',
}
